import _ from "lodash";
import {
  inject,
  computed,
  defineComponent,
  ref,
  PropType,
  reactive,
  toRefs,
  watch,
  onMounted,
} from "vue";
import { message } from "ant-design-vue";
import FileStatus from "./file-status.vue";
import { FileUploadService, BizFileService } from "@/core";
import { generateUuid, getFileExt } from "@/utils";
import { FileRecord, UploadStatus } from "@/core/services/file-upload.interface";
import columns from "./attachment-table-two-constant";
import { submitSuccessEmitter } from "@/utils/emitter";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
interface IState {
  uploading: boolean;
  visible: boolean;
  fileList: FileRecord[];
}
export default defineComponent({
  isGlobal: true,
  name: "Attachment",
  components: { FileStatus },
  props: {
    value: {
      type: Array as PropType<FileRecord[]>,
      default: () => [],
    },
    uploadedCount: {
      type: Number,
      default: 0,
    },
    uploadButtonText: {
      type: String,
      default: "上传附件",
    },
    maxCount: {
      type: Number,
      default: 100,
    },
    maxSize: {
      type: Number,
      default: 100, // 100M
    },
    allowEdit: {
      type: Boolean,
      default: undefined,
    },
    bizId: {
      type: String,
      require: true,
    },
    bizType: {
      type: String,
      require: true,
    },
    uploadAccess: {
      type: String,
    },
    downloadAccess: {
      type: String,
    },
    deleteAccess: {
      type: String,
    },
    class: {
      type: String,
      default: "responsive-table",
    },
  },
  emits: ["ok", "update:value"],
  setup(props, { emit }) {
    // const parentState = (inject("parentState") || {}) as any;
    const { run } = BizFileService.useCreateApi();
    const state = reactive<IState>({
      uploading: false,
      visible: false,
      fileList: [],
    });

    const disabled = computed(() => {
      const rest = props.maxCount - props.uploadedCount;
      return rest <= 0;
    });

    const deleteFile = (file: FileRecord) => {
      state.fileList = state.fileList.filter((item) => item.uid !== file.uid);
      emit("update:value", state.fileList);
    };

    const openPreview = async(url: any) => {
      // console.log("url", url);
      let requestUrl_1 = 'https://preview.homedo.com/view?func=todo&format=json&src='
      let requestUrl_2 = requestUrl_1 + url
      let res:any = await BizFileService.previewApi(requestUrl_2);
      window.open(res.data.result);
    };

    watch(
      () => props.value,
      (newValue) => {
        if (newValue?.length) {
          newValue.forEach((file) => {
            file.status = UploadStatus.SUCCESS;
            if (!file.uid) {
              file.uid = generateUuid();
            }
          });
          if (newValue.length) {
            state.fileList = newValue;
            // console.log("_.cloneDeep(files)", state.fileList);
          }
        }
      },
      { immediate: true, deep: true }
    );

    onMountedOrActivated(() => {
      state.fileList = props.value;
    });

    return {
      ...toRefs(state),
      disabled,
      columns,
      deleteFile,
      openPreview,
    };
  },
});
